module.exports = __webpack_public_path__ + "static/img/carousel3.72064560.png";